angular.module('impactx.passwordrecovery').controller('PasswordRecoveryCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$mdDialog',
    'LegalLinking',
    'AppConfiguration',
    PasswordRecoveryCtrl]);

function PasswordRecoveryCtrl($scope, dataGen, $routeParams, $mdDialog, LegalLinking, AppConfiguration) {
    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.imprintURL = AppConfiguration.get('imprintURL');
    $scope.privacyPolicy = AppConfiguration.get('privacyPolicy');
    $scope.generalTerms = AppConfiguration.get('generalTerms');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    dataGen.getData($scope, {osuTAN: $routeParams.osuTAN}, "/passwordrecovery/validaterequest").then(function (data) {
        $mdDialog.show({
            templateUrl: 'modules/passwordrecovery/templates/passwordrecovery.dialog.html',
            controller: 'PasswordRecoveryDialogCtrl',
            controllerAs: "passwordRecoveryDialogCtrl",
            locals: {
                passwordRecoveryData: data
            },
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false,
        });
    });

    $scope.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };
}